const formatStatus = (input: string) => {
  if (!input) return input;
  switch (input) {
    case 'confirm':
      return 'Confirmed';
    case 'cancel':
      return 'Cancelled';
    case 'new':
      return 'New';
    case 'deny':
      return 'Denied';
    case 'attempted':
      return 'Attempted';
    case 'removed':
      return 'Removed';
    case 'time_change':
      return 'Time Change';
    case 'pending_multi_conf':
      return 'Pending - Waiting For Others';

    default:
      return input
        .replace(/_/g, ' ')
        .replace(/(^| )(\w)/g, x => x.toUpperCase());
  }
};

export default formatStatus;
